import { FieldTestsStorageSerializer } from "./FieldTestsStorageSerializer";
import { LocalStorage } from "./LocalStorage";
import { StorageManager } from "./StorageManager";
export class FieldTestsStorageManager {
    constructor() { }
    static getInstance() {
        if (FieldTestsStorageManager.instance === undefined) {
            FieldTestsStorageManager.instance = new StorageManager({
                storage: LocalStorage.create(),
                storageKey: "fieldTestExperiments",
                storageSerializer: new FieldTestsStorageSerializer(),
            });
        }
        return FieldTestsStorageManager.instance;
    }
    static restore() {
        return FieldTestsStorageManager.getInstance().restore();
    }
    static store(toStore) {
        return FieldTestsStorageManager.getInstance().store(toStore);
    }
}
